import React, { Component } from "react";

class Reactions extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			emojies: [
				{
					'name': 'Like',
					'image': './images/like_emoji.svg'
				},
				{
					'name': 'Meh',
					'image': './images/dislike_emoji.svg'
				},
				{
					'name': 'Easy',
					'image': './images/easy_emoji.svg'
				},
				{
					'name': 'Ouch',
					'image': './images/ouch_emoji.svg'
				},
				{
					'name': 'Beast',
					'image': './images/beast_emoji.svg'
				},
				{
					'name': 'Cool',
					'image': './images/cool_emoji.svg'
				}
			],
		}
	}
 
	componentDidMount(){
		
	}
	
	
	render() {
		return (
			<div className="reactions_container">
				<div className="close_emoji" onClick={() => this.props.updateStateFromChild({openReactions: false})}></div>
				{ this.state.emojies.map((item, key) => 
					<div className="one_emoji" id={item.name} key={key}>
						<div className="emoji_icon" style={{backgroundImage: "url('" + item.image + "')"}}></div>
						<div className="emoji_title">{item.name}</div>
					</div>
				)}
			</div>		
	)}
}
export default Reactions;
